const getActiveChatStorageKeys = () => {
  const activeChatStorageKeys = [];
  const activeChatStorage = 'gcmcsessionActive';
  const activeChatGarbage = 'gcmcopn';

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);

    if (key.includes(activeChatStorage) || key.includes(activeChatGarbage)) {
      activeChatStorageKeys.push(key);
    }
  }

  return activeChatStorageKeys;
};

const clearUserChatStorage = () => {
  localStorage.removeItem('_gcatkn');
  localStorage.removeItem('_gcartkn');
};

export const clearChatStorage = () => {
  localStorage.removeItem('_actmu');
  localStorage.removeItem('_actms');
  localStorage.removeItem('_actvc');
  localStorage.removeItem('_actts');
};

export const clearActiveChatStorage = () => {
  const activeChatStorageKeys = getActiveChatStorageKeys();

  activeChatStorageKeys.forEach((key) => {
    localStorage.removeItem(key);
  });
};

export const clearAllStorage = () => {
  clearChatStorage();
  clearActiveChatStorage();
  clearUserChatStorage();
};
